export default __webpack_public_path__ + "static/media/blob-rosa.88c07e42.png";